import React, { useState, useEffect } from 'react';
import { Users, FileText, Umbrella, UserPlus, AlertTriangle, Clock, UserMinus } from 'lucide-react';
import useTokenValidation from 'hooks/useTokenValidation';
import { CompanyChangeBlur } from 'components/common';
import PageLayout from 'components/common/PageLayout';
import { usePermissions } from 'hooks/usePermissions';

import FuncionariosTab from 'features/dp/components/funcionarios/FuncionariosTab';
import FolhaTab from 'features/dp/components/folha/FolhaTab';

import FeriasTab from 'features/dp/components/ferias/FeriasTab';
import AdmissoesTab from 'features/dp/components/admissoes/AdmissoesTab';
import AfastamentosTab from 'features/dp/components/afastamentos/AfastamentosTab';
import BancoHorasTab from 'features/dp/components/banco-horas/BancoHorasTab';
import RescisoesTab from 'features/dp/components/rescisoes/RescisoesTab';

const TABS = [
  { id: 'funcionarios', label: 'Funcionários', icon: Users, permission: 'dp.funcionarios.view' },
  { id: 'folha', label: 'Folha de Pagamento', icon: FileText, permission: 'dp.folha.view' },
{ id: 'ferias', label: 'Férias', icon: Umbrella, permission: 'dp.ferias.view' },
  { id: 'admissoes', label: 'Admissões', icon: UserPlus, permission: 'dp.admissoes.view' },
  { id: 'afastamentos', label: 'Afastamentos', icon: AlertTriangle, permission: 'dp.afastamentos.view' },
  { id: 'banco-horas', label: 'Cartão de Ponto', icon: Clock, permission: 'dp.banco_horas.view' },
  { id: 'rescisoes', label: 'Rescisões', icon: UserMinus, permission: 'dp.rescisoes.view' },
];

const DepartamentoPessoal = () => {
  useTokenValidation();
  const { hasPermission } = usePermissions();

  const temPermissaoDP = () => {
    return hasPermission('dp.view') || TABS.some(t => hasPermission(t.permission));
  };

  const getAbaInicial = () => {
    for (const tab of TABS) {
      if (hasPermission(tab.permission)) return tab.id;
    }
    return TABS[0].id;
  };

  const [abaAtiva, setAbaAtiva] = useState(getAbaInicial());

  const podeEditar = (modulo) => hasPermission(`dp.${modulo}.edit`) || hasPermission('dp.edit');

  useEffect(() => {
    const handleCompanyChange = () => {};
    window.addEventListener('company-changed', handleCompanyChange);
    return () => window.removeEventListener('company-changed', handleCompanyChange);
  }, []);

  if (!temPermissaoDP()) {
    return (
      <PageLayout>
        <div className="min-h-screen bg-[color:var(--surface-muted)] flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-[color:var(--text)]">Acesso Negado</h1>
            <p className="text-[color:var(--text-muted)] mt-2">Você não tem permissão para acessar o Departamento Pessoal.</p>
          </div>
        </div>
      </PageLayout>
    );
  }

  return (
    <>
      <CompanyChangeBlur />
      <PageLayout>
        <div className="w-full p-6">

          {/* Tab Navigation */}
          <div className="mb-8">
            <div className="border-b border-[color:var(--border)]">
              <nav className="-mb-px flex space-x-6 overflow-x-auto">
                {TABS.map(tab => (
                  hasPermission(tab.permission) && (
                    <button
                      key={tab.id}
                      onClick={() => setAbaAtiva(tab.id)}
                      className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors whitespace-nowrap ${
                        abaAtiva === tab.id
                          ? 'border-[color:var(--accent)] text-[color:var(--accent)]'
                          : 'border-transparent text-[color:var(--text-muted)] hover:text-[color:var(--text-primary)]'
                      }`}
                    >
                      <div className="flex items-center space-x-2">
                        <tab.icon className="h-4 w-4" />
                        <span>{tab.label}</span>
                      </div>
                    </button>
                  )
                ))}
              </nav>
            </div>
          </div>

          {/* Tab Content */}
          {abaAtiva === 'funcionarios' && <FuncionariosTab podeAdicionar={podeEditar('funcionarios')} />}
          {abaAtiva === 'folha' && <FolhaTab podeEditar={podeEditar('folha')} />}
{abaAtiva === 'ferias' && <FeriasTab podeEditar={podeEditar('ferias')} />}
          {abaAtiva === 'admissoes' && <AdmissoesTab podeEditar={podeEditar('admissoes')} />}
          {abaAtiva === 'afastamentos' && <AfastamentosTab podeEditar={podeEditar('afastamentos')} />}
          {abaAtiva === 'banco-horas' && <BancoHorasTab podeEditar={podeEditar('banco_horas')} />}
          {abaAtiva === 'rescisoes' && <RescisoesTab podeEditar={podeEditar('rescisoes')} />}
        </div>
      </PageLayout>
    </>
  );
};

export default DepartamentoPessoal;
